module.exports = __webpack_public_path__ + "static/media/reanimationlabsbannerW.2dd52835.svg";